// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Input_wrapper__3u3wz","wrapperError":"Input_wrapperError__2jE_H","input":"Input_input__2TowH","label":"Input_label__3Wv0o"};